module.exports = __webpack_public_path__ + "img/Tour Aussie.b3c38397.jpg";